import React, { useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import api from "../../utils/apiAuth";
import AddSkill from "../../components/AddSkill";

const Yetkinlikler = ({ skills, setSkills }) => {
  const [options, setOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // API'den yetkinlikleri çekme
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await api.get("/skills");
        setOptions(response.data.data || []); // API'den gelen yetkinlikleri state'e ekle
      } catch (error) {
        setOptions([]); // Hata durumunda boş dizi
      }
    };
    fetchSkills();
  }, []);

  const filteredOptions = options.filter((option) => {
    const skillName = option.name || option;
    return skillName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const addSkill = (skillName) => {
    if (!skills.includes(skillName)) {
      setSkills([...skills, skillName]);
    }
  };

  const removeSkill = (skillName) => {
    setSkills(skills.filter((item) => item !== skillName));
  };

  return (
    <div className="w-full">
      <AddSkill
        options={filteredOptions}
        selectedValues={skills}
        onSelect={addSkill}
        onDeselect={removeSkill}
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        placeholder="Bir yetkinlik seçiniz"
        label="Hangi Yetkinliklere Sahipsin?"
      />

      <div className="flex flex-wrap gap-1 mt-2">
        {skills.map((skill) => (
          <button
            key={skill}
            className="btn-green text-dark flex items-center gap-2 text-sm h-[36px] rounded-lg"
          >
            <span>{skill}</span>
            <span onClick={() => removeSkill(skill)}>
              <IoIosCloseCircle />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Yetkinlikler;
